import NoDataComponent from '@Components/General/Feedback/no-data-component';
import { FilterAltOffRounded, SearchOffRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const NoGroupsFound = () => {
    const { t } = useTranslation();

    return (
        <NoDataComponent
            primary={t('prompts:noData.groups.notFound.primary')}
            secondary={t('prompts:noData.groups.notFound.secondary')}
            Icon={SearchOffRounded}
            action={
                <Button
                    startIcon={<FilterAltOffRounded />}
                    variant="tonal"
                    color="secondary"
                    LinkComponent={Link}
                    to="."
                >
                    {t('Clear Filters')}
                </Button>
            }
        />
    );
};

export default NoGroupsFound;
